import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { ProgramRole } from '@app/shared/enums/program-role.enum';
import { MtProgramUserListApiModel } from '@app/api/api-models/program/mentoring/MtProgramUserListApiModel';
import { HttpClientService } from '@app/api/api-services/http-client.service';

@Injectable()
export class MtProgramUsersService {
  public apiUrl = 'mt-program-users';

  constructor(private readonly http: HttpClientService) {}

  public getList(role: ProgramRole): Observable<MtProgramUserListApiModel[]> {
    return this.http
      .get<MtProgramUserListApiModel[]>(`${this.apiUrl}/get-list/${role}`)
      .pipe(map((array) => array.map((x) => new MtProgramUserListApiModel().deserialize(x))));
  }
}
